const CheckIcon = ({showWhen}) => {
    if(showWhen) {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="127" height="126" viewBox="0 0 127 126" fill="none">
                <circle opacity="0.2" cx="63.5586" cy="63" r="63" fill="#32CDAB" />
                <circle cx="63.5586" cy="63" r="40.5" fill="#00B999" />
                <path d="M48.8398 66L58.4961 75.6562L84.6523 50.3438" stroke="white" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    }
    return null;
};

export default CheckIcon;
